export const BRAND = {
  name: "licito.guru",
  logoUrl: "/licito-guru-logo.png",
  logo3D:
    "https://static.wixstatic.com/media/a4fc81_7614f3b2ed3640f897756f37db2def55~mv2.webp/v1/fill/w_1200,h_1200,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/licito3d.webp",
};

export const WHATSAPP_URL =
  "https://wa.me/554198002461?text=Ol%C3%A1%2C%20quero%20agendar%20uma%20demonstra%C3%A7%C3%A3o%20da%20licito.guru";

export const CONTACT = {
  phone1: "(41) 99800-2461",
  phone2: "(48) 3204-7194",
  email: "comercial@licito.guru",
  address:
    "Av. Osvaldo Rodrigues Cabral, 1570, Centro, Florianópolis/SC, CEP 88015-710",
  whatsapp: WHATSAPP_URL,
};

export const CLIENT_LOGOS = [
  "https://static.wixstatic.com/media/a4fc81_d0b0d78a4bf74721a6b33e097ad966d9~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_3c3c5a675dfc4daaa34d8c7f95cfc5aa~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_ad24633da06a4a08ab658684b1b77368~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_3cc5b5e3f76840869261779e9cf06121~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_93a3a23bf9934a31ae71e33de5d516fe~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_36817af09d6e4b59ac26a1dee5c564c8~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_22002d119ff24594b7b315cb21395612~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_1d053338a2364b969ea5b1b438f5933a~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_d597f280e48d486c9feb93272432b49d~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_f1103bf337f944b4a23cd525fb0ef903~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_e8dfb42b65fe42dcbde71f21d05cc1e1~mv2.webp",
  "https://static.wixstatic.com/media/a4fc81_73fb0bc5ba7243ccba93aa822ff9d724~mv2.webp",
];

export const PRODUCT_SHOTS = {
  gerador:
    "https://static.wixstatic.com/media/353847_2489075bc0fd407d8ee922fe3204e762~mv2.webp/v1/fill/w_1303,h_735,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/gerar%20documentos.webp",
  analise:
    "https://static.wixstatic.com/media/353847_033a2083ea1e4dae91fe868bfefac79b~mv2.webp/v1/fill/w_1307,h_739,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/analise%20documentos.webp",
  consultoria:
    "https://static.wixstatic.com/media/a4fc81_a62cde7e60da491584a55de2d0b85641~mv2.webp/v1/fill/w_1081,h_613,al_c,q_85,enc_avif,quality_auto/consultoria.webp",
  pesquisa:
    "https://static.wixstatic.com/media/353847_db4f078d982d459ea05955628efd4a0b~mv2.webp/v1/fill/w_1306,h_731,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/pesquisa%20de%20precos.webp",
  radar:
    "https://static.wixstatic.com/media/353847_36004f3350474303a32430a5113c2703~mv2.webp/v1/fill/w_1306,h_740,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/radar%20fornecedor.webp",
  ata:
    "https://static.wixstatic.com/media/353847_0ccfb613f5b34ecc8d252b092d63b00e~mv2.webp/v1/fill/w_1306,h_740,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/ata%20inteligente.webp",
  personalizacao:
    "https://static.wixstatic.com/media/a4fc81_c033c055156e4c33b7dfb88d81742c0e~mv2.webp/v1/fill/w_1307,h_705,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/personalizado.webp",
  founders:
    "https://static.wixstatic.com/media/353847_c14363cc8df34536a90cff35ff7cfc63~mv2.webp/v1/fill/w_544,h_513,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/joel-e-gustavo.webp",
};

/**
 * Product videos per feature. When present, replaces the static image.
 */
export const PRODUCT_VIDEOS = {
  consultoria:
    "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/m7ocv1ye_consultas.mp4",
  gerador:
    "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/mn94mcxv_gerador%20de%20documentos.mp4",
  analise:
    "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/q76zm52c_Analisador%20de%20Documentos.mp4",
  pesquisa:
    "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/xw3p8q54_PESQUISA%20DE%20PRE%C3%87O.mp4",
  radar:
    "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/7ygpzpme_RADAR%20DE%20FORNECEDOR.mp4",
  ata:
    "https://customer-assets-v7afamib.emergentagent.net/job_guru-landing-v2/artifacts/ryjvcp03_ATA%20INTELIGENTE.mp4",
};

/**
 * Demo tabs — three primary uses of the platform.
 */
export const DEMO_TABS = [
  {
    id: "personalizacao",
    label: "Personalização",
    title: "Sua IA, suas regras.",
    desc:
      "A licito.guru IA pode ser personalizada para o seu órgão, com os seus editais, contratos, documentos técnicos, pareceres jurídicos e normas internas, tudo isso com a identidade do seu órgão.",
    img: "personalizacao",
  },
  {
    id: "banco-de-dados",
    label: "Banco de dados Personalizado",
    title: "O conhecimento do seu órgão, integrado à IA.",
    desc:
      "Reunimos e organizamos os conteúdos específicos do seu órgão em uma base exclusiva de conhecimento. Assim, no módulo de Consulta, a IA responde considerando os documentos, entendimentos, procedimentos e regras internas da instituição, com informações mais contextualizadas para a sua realidade.",
    img: "consultoria",
  },
  {
    id: "documentos-personalizados",
    label: "Documentos Personalizados",
    title: "Documentos criados conforme o padrão do seu órgão.",
    desc:
      "Configuramos modelos, estruturas, campos obrigatórios, padrões de redação e critérios utilizados pelo seu órgão. Dessa forma, no módulo Gerador de Documentos, a Inteligência Artificial produz minutas alinhadas à identidade institucional e ao formato adotado pela sua equipe.",
    img: "gerador",
  },
];

/**
 * Features — texts preserved verbatim from the original site.
 * Presented via tabs (desktop) / accordion (mobile).
 * Order requested by client: Consultas, Gerador, Analisador, Pesquisa, Radar, Ata.
 */
export const FEATURES = [
  {
    id: "consultas",
    tab: "Consultas",
    title: "IA especializada com banco de dados exclusivo.",
    titleParts: [
      { text: "IA especializada com " },
      { text: "banco de dados exclusivo.", accent: true },
    ],
    text:
      "Esclareça dúvidas sobre licitações e contratos com respostas fundamentadas na jurisprudência do TCU e dos TCEs, na regulamentação federal e nas obras do Prof. Joel de Menezes Niebuhr. Treinada pelo Prof. Gustavo Schiefler e sua equipe, a licito.guru IA combina inteligência artificial com conhecimento especializado.",
    highlights: [
      "Jurisprudência TCU e TCEs",
      "Regulamentação federal",
      "Obras doutrinárias integrais",
    ],
    img: "consultoria",
  },
  {
    id: "gerador",
    tab: "Gerador de Documentos",
    title: "Semanas de trabalho, entregues em minutos.",
    titleParts: [
      { text: "Semanas de trabalho, " },
      { text: "entregues em minutos.", accent: true },
    ],
    text:
      "Você responde um questionário guiado. A plataforma gera ETP, DFD, Termo de Referência, Ata, Contrato, Documento do Edital e Mapa de Riscos consistentes entre si e alinhados à Lei 14.133.",
    highlights: [
      "ETP, DFD, TR, Ata, Contrato, Edital e Mapa de Riscos",
      "Consistência entre documentos",
      "Alinhamento à Lei 14.133",
    ],
    img: "gerador",
  },
  {
    id: "analisador",
    tab: "Analisador de Documentos",
    title: "Evite riscos jurídicos. Analise seus documentos em instantes.",
    titleParts: [
      { text: "Evite riscos jurídicos.", accent: true },
      { text: " Analise seus documentos em instantes." },
    ],
    text:
      "Suba um edital ou contrato já existente. Cada trecho em risco é apontado, classificado por gravidade e devolvido com sugestão de redação corrigida.",
    highlights: [
      "Trechos em risco apontados",
      "Classificação por gravidade",
      "Sugestão de redação corrigida",
    ],
    img: "analise",
  },
  {
    id: "pesquisa",
    tab: "Pesquisa de Preços",
    title: "Não é uma simples cotação, mas sim o orçamento estimado.",
    titleParts: [
      { text: "Não é uma simples cotação, mas sim o " },
      { text: "orçamento estimado.", accent: true },
    ],
    text:
      "Integra o PNCP, a API do próprio Google e as tabelas oficiais. A IA define o critério e o desvio-padrão, e a cesta de preços sai pronta para revisão, com a evidência de cada fonte. Aba própria para inexigibilidade.",
    highlights: [
      "Integração PNCP + Google + tabelas oficiais",
      "Critério e desvio-padrão pela IA",
      "Aba própria para inexigibilidade",
    ],
    img: "pesquisa",
    tag: "Novo",
  },
  {
    id: "radar",
    tab: "Radar de Fornecedores",
    title: "Não é uma busca no Google. É um relatório inteligente.",
    titleParts: [
      { text: "Não é uma busca no Google. É um " },
      { text: "relatório inteligente.", accent: true },
    ],
    text:
      "Relatório completo pelo CNPJ ou nome: sócios, administrador, capital social, contratos com a administração, certidões, sanções e mídia, tudo com links.",
    highlights: [
      "Sócios, administrador e capital social",
      "Contratos com a administração",
      "Certidões, sanções e mídia com links",
    ],
    img: "radar",
    tag: "Novo",
  },
  {
    id: "ata",
    tab: "Ata Inteligente",
    title: "Não é só achar a ata. É adesão instruída.",
    titleParts: [
      { text: "Não é só achar a ata." },
      { break: true },
      { text: "É adesão instruída.", accent: true },
    ],
    text:
      "Atas vigentes e IRPs federais com preços unitários e limite de adesão por item, cruzadas com seu ETP, e a minuta da justificativa no padrão que o TCU exige.",
    highlights: [
      "Atas vigentes e IRPs federais",
      "Preços unitários e limite de adesão por item",
      "Minuta da justificativa no padrão TCU",
    ],
    img: "ata",
    tag: "Novo",
  },
];
